import { Button, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from "@mui/material"
import DialogForm from "../../../shared/components/DialogForm"
import { IOSSwitch } from "../ReservationView"
import { useTranslation } from "react-i18next";
import { useEffect } from "react";


const ChangeStatusReservationDialog = (props) => {
  const { t } = useTranslation();

  let {
    openChangePaymentTypeDialog ,
    handleChangePaymentTypeDialog,
    handalepaymentType,
    handaleCardPresent,
    card_present,
    paymentType,
    setCradsDetail,
    cardDetail,
    card,
    handeleCardChange,
    month,
    yearList,
    addCardDetail,
    handlePinpadDevice,
    pinpadDevicesList,
    handlePaymentTypeSubmit,
    selectPinpadDevices,
    reservationDetail,
    isCashAllowed,
  } = props

   useEffect(() => {
      if (isCashAllowed === 1 && paymentType=== 1) {
      }else{
         handalepaymentType({
          target: {
            value: 2,
          },
        });
      }
    }, [isCashAllowed, openChangePaymentTypeDialog]);

    return (
        <DialogForm
        scroll="paper"
        maxWidth="lg"
        // maxWidth="mb"
        title={t("Change Payment Type")}
        openDialog={openChangePaymentTypeDialog}
        handleDialogClose={handleChangePaymentTypeDialog}
        bodyContent={
          <div className="p-2">
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item md={3} xs={12} className="mt-2">
                <Typography
                id="font-600"
                  variant="h4"
                  style={{
                    marginBottom: "11px",
                    color: "rgb(30, 30, 30)",
                    fontSize: "16px",
                    lineHeight: "24px",
                  }}
                >
                  {t("Payment Option")}
                </Typography>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {t("Payment Type")}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    value={paymentType}
                    label="Payment Type"
                    onChange={(e) => handalepaymentType(e)}
                  >
                     {isCashAllowed === 1 && (
                    <MenuItem value={1}>{t("Cash")}</MenuItem>)}
                    <MenuItem value={2}>{t("Credit Card")}</MenuItem>
                       {/* {/* <MenuItem value={3}>{t("Cheque")}</MenuItem>  */}
                       {reservationDetail?.is_corporate_booking === 1 &&
                     (<MenuItem value={4}>{t("Direct Bill")}</MenuItem>) }
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={3} xs={12} style={{ left: "20px" }} className="mt-2">
                {paymentType === 2 && (
                  <>
                    <Typography
                      variant="h4"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Card Present")}
                    </Typography>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          sx={{ m: 1 }}
                          checked={card_present}
                          onChange={(e) => handaleCardPresent(e)}
                        />
                      }
                      label={""}
                    />
                  </>
                )}
              </Grid>
              {card_present === false && paymentType === 2 && (
                
                <Grid item xs={12}>
                    <div style={{
                      border: "2px solid #B4ADAD",
                      borderRadius: "5px",
                      width: "100%",
                      marginTop: "25px",
                      paddingBottom: "10px",
                      height: "fit-content",
                    }}>
                  <Grid
                    sx={{
                      padding: "20px",
                    }}
                    container
                    spacing={2}
                  >
                  <Grid item md={2} xs={12}>
                    <Typography
                    id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Select Card")}
                    </Typography>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        {t("Select Card")}
                      </InputLabel>
                      <Select
                        // style={{ width: '200px' }}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        onChange={(e) => setCradsDetail(e)}
                        value={card?.id}
                        // value={card?.user_id}
                        // value={cancelPolicy}
                        label="Select Card"
                      >
                        <MenuItem value={0}>{t("Add Card")}</MenuItem>
                        {cardDetail.map((item) => (
                          <MenuItem value={item.id} key={item.id}>
                            {item.card_holder_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <Typography
                    id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Card Holder Name")}
                    </Typography>
                    <TextField
                      value={card?.card_holder_name}
                      disabled={
                        !(card?.id == 0 || Number.isNaN(card?.id))
                      }
                      placeholder={t("Card Holder Name")}
                      onChange={(e) => handeleCardChange(e)}
                      name="card_holder_name"
                      id="group_name"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <Typography
                    id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Card Number")}
                    </Typography>
                    <TextField
                      value={card?.card_number}
                      placeholder={t("Card Number")}
                      disabled={
                        !(card?.id == 0 || Number.isNaN(card?.id))
                      }
                      type="text" // Change from "number" to "text"
                      inputMode="numeric" // Ensures only numbers show up in the keyboard
                      // type={
                      //   card?.id == 0 || Number.isNaN(card?.id) ? "number" : ""
                      // }
                      name="card_number"
                      onChange={(e) => {
                        const value = e.target.value.replaceAll(/\D/g, ""); // Remove non-numeric characters
                        if (value?.length > 16) {
                          return;
                        }
                        handeleCardChange({target: {  name: e.target.name, value } })}
                      }
                      id="group_name"
                    />
                  </Grid>
                  <Grid item md={1} xs={12}>
                    <Typography
                    id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Expiry")}
                    </Typography>
                    <FormControl fullWidth>
                      <InputLabel title={"Month"}>{"MM"}</InputLabel>
                      <Select
                        name="mm"
                        input={<OutlinedInput label="MM" />}
                        label="Month"
                        disabled={
                          !(card?.id == 0 || Number.isNaN(card?.id))
                        }
                        onChange={(e) => handeleCardChange(e)}
                        value={card?.mm + ''}
                      >
                        <MenuItem value={""}>{t("MM")}</MenuItem>
                        {month.map((item) => (
                          <MenuItem key={item} value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={1} xs={12}>
                    <Typography
                      style={{
                        marginBottom: "35px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {" "}
                    </Typography>
                    <FormControl fullWidth>
                      <InputLabel title={"Year"}>{"YYYY"}</InputLabel>
                      <Select
                        name="yyy"
                        input={<OutlinedInput label="YYYY" />}
                        label="Year"
                        disabled={
                          !(card?.id == 0 || Number.isNaN(card?.id))
                        }
                        onChange={(e) => handeleCardChange(e)}
                        value={card?.yyy + ''}
                      >
                        <MenuItem value={""}>{t("YYYY")}</MenuItem>
                        {yearList.map((item) => (
                          <MenuItem key={item} value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {card?.id == 0 || Number.isNaN(card?.id) ? (
                    <Grid item md={1.8} xs={12}>
                      <Typography
                      id="font-600"
                        style={{
                          marginBottom: "11px",
                          color: "rgb(30, 30, 30)",
                          fontSize: "16px",
                          lineHeight: "24px",
                        }}
                      >
                        {t("Security Code")}
                      </Typography>
                      <TextField
                        value={card?.cvv}
                        disabled={
                          !(card?.id == 0 || Number.isNaN(card?.id))
                        }
                        onChange={(e) => handeleCardChange(e)}
                        placeholder={t("CVV")}
                        name="cvv"
                        id="cvv"
                        type="number"
                      />
                    </Grid>
                  ) : (
                    <Grid item md={1.8} xs={12}>
                      <Typography
                      id="font-600"
                        style={{
                          marginBottom: "11px",
                          color: "rgb(30, 30, 30)",
                          fontSize: "16px",
                          lineHeight: "24px",
                        }}
                      >
                        {t("Card Type")}
                      </Typography>
                      <TextField
                        value={card?.card_type}
                        disabled={
                          !(card?.id == 0 || Number.isNaN(card?.id))
                        }
                        // onChange={(e) => handeleCardChange(e)}
                        placeholder={t("Card Type")}
                        name="Card Type"
                        id="Card Type"
                      />
                    </Grid>
                  )}
                  {card?.id == 0 || Number.isNaN(card?.id) ? (
                    <Grid item md={12} xs={12}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "rgb(30, 30, 30)",
                          fontSize: "16px",
                          lineHeight: "24px",
                        }}
                      ></Typography>
                      <Button
                        variant="contained"
                        onClick={addCardDetail}
                        title="Cancel"
                        className="comman-button"
                        // style={{
                        //   width: "150px",
                        //   height: "47px",
                        //   // marginTop: "23px",
                        // }}
                      >
                        {t("Add & Verify")}
                      </Button>
                    </Grid>
                  ) : (
                    ""
                  )}
                </Grid>
                </div>
                </Grid>
              )}
              {card_present === true && paymentType === 2 && (
                <Grid item xs={12}>
                <div style={{
                  border: "2px solid #B4ADAD",
                  borderRadius: "5px",
                  width: "100%",
                  marginTop: "25px",
                  paddingBottom: "10px",
                  height: "fit-content",
                }}>
              <Grid
                sx={{
                  padding: "20px",
                }}
                container
                spacing={2}
              >
                  <Grid item md={4} xs={12}>
                    <Typography
                    id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Pinpad Devices")}
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        onChange={(e) => handlePinpadDevice(e)}
                        value={selectPinpadDevices}
                      >
                        <MenuItem value={0}>{t("-- select --")}</MenuItem>
                        {pinpadDevicesList?.map((item) => (
                          <MenuItem value={item.device_id} key={item.id}>
                            {item.device_id}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                </div>
                </Grid>

              )}
              <Grid item md={12} xs={12} sx={{width:"100%"}}>
                <Button
                  className="mt-1 comman-button"
                  size="large"
                  variant="contained"
                  onClick={handlePaymentTypeSubmit}
                  disableElevation
                  color="primary"
                  // style={{
                  //   justifyContent: "center",
                  //   width: "98px",
                  //   height: "44px",
                  //   textTransform: "capitalize",
                  //   background:
                  //     "linear-gradient(180deg, #255480 0%, #173450 100%)",
                  // }}
                >
                  {t("Submit")}
                </Button>
              </Grid>
            </Grid>
          </div>
        }
      />
    )
}

export default ChangeStatusReservationDialog;